package vegasful.admin

inline fun <T : Any> jso(builder: T.() -> Unit): T = jso<T>().apply(builder)
fun <T : Any> jso(): T = js("({})") as T